import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faq").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="faq-page" className="py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">FAQ</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">The Common Questions</h1>
        <Accordion type="single" collapsible className="mt-10">
          {items.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="kr-card rounded-xl mb-3 px-5 border" data-testid={`faq-${f.id}`}>
              <AccordionTrigger className="text-left font-display uppercase text-lg hover:no-underline">{f.question}</AccordionTrigger>
              <AccordionContent className="text-slate-300 leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
